export const COLOR = {
  brand: '#3546FF',
  brandHover: '#2E3DE6',
  brandActive: '#2833C7',
  brandSoft: '#5462FF',
  brandLine: '#D6DEFF',
  brandTint: '#F2F6FF',
  brandTintHover: '#E8EEFF',

  ink: '#222B45',
  inkMuted: '#8F9BB3',
  inkDisabled: '#C5CEE0',
  inkInverse: '#FFFFFF',

  line: '#E4E9F2',
  lineSoft: '#EDF1F7',
  lineStrong: '#D5DDE8',

  surface: '#FFFFFF',
  surfaceMuted: '#FAFBFC',
  surfaceSubtle: '#F7F9FC',
  surfaceRaised: '#EDF1F7',

  success: '#00B887',
  successText: '#008E62',
  successTint: '#F0FFF8',
  successLine: '#CCFCE3',

  danger: '#FF3D71',
  dangerText: '#DB2C66',
  dangerTint: '#FFF4F6',
  dangerLine: '#FFE0E9',

  warning: '#FFB023',
  warningText: '#B26A00',
  warningTint: '#FFF8EC',
  warningLine: '#FFE7BF',

  simulation: '#7C3AED',
  simulationTint: '#F5F3FF',
  simulationLine: '#DDD6FE',
};

export const FOCUS_RING =
  'focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3546FF]/35 focus-visible:ring-offset-1 focus-visible:ring-offset-white';

export const TRANSITION = 'transition-colors duration-200';

export const SURFACE = {
  page: 'bg-white',
  muted: 'bg-[#FAFBFC]',
  subtle: 'bg-[#F7F9FC]',
  raised: 'bg-[#EDF1F7]',
  brandTint: 'bg-[#F2F6FF]',
  brandTintHover: 'bg-[#E8EEFF]',
};

export const BORDER = {
  card: 'border-[#E4E9F2]',
  soft: 'border-[#EDF1F7]',
  strong: 'border-[#D5DDE8]',
  brand: 'border-[#3546FF]',
  brandSoft: 'border-[#D6DEFF]',
};

export const TEXT = {
  body: 'text-[#222B45]',
  muted: 'text-[#8F9BB3]',
  disabled: 'text-[#C5CEE0]',
  brand: 'text-[#3546FF]',
  brandSoft: 'text-[#5462FF]',
  inverse: 'text-white',
  positive: 'text-[#008E62]',
  negative: 'text-[#DB2C66]',
  warning: 'text-[#B26A00]',
  simulation: 'text-[#7C3AED]',
};

const CONTROL_BASE = `inline-flex items-center justify-center gap-2 font-Satoshi font-medium whitespace-nowrap ${TRANSITION} ${FOCUS_RING}`;

export const BUTTON_VARIANT = {
  primary:
    'bg-[#3546FF] text-white border border-transparent hover:bg-[#2E3DE6] active:bg-[#2833C7] disabled:bg-[#C5CEE0] disabled:text-white',
  secondary:
    'bg-white text-[#222B45] border border-[#D5DDE8] hover:bg-[#F7F9FC] hover:border-[#C5CEE0] active:bg-[#EDF1F7] disabled:text-[#C5CEE0] disabled:bg-white disabled:border-[#E4E9F2]',
  ghost:
    'bg-transparent text-[#222B45] border border-transparent hover:bg-[#F7F9FC] active:bg-[#EDF1F7] disabled:text-[#C5CEE0] disabled:bg-transparent',
  subtle:
    'bg-[#F2F6FF] text-[#3546FF] border border-transparent hover:bg-[#E8EEFF] active:bg-[#D6DEFF] disabled:bg-[#F7F9FC] disabled:text-[#C5CEE0]',
  outline:
    'bg-white text-[#3546FF] border border-[#3546FF] hover:bg-[#F2F6FF] active:bg-[#E8EEFF] disabled:text-[#C5CEE0] disabled:bg-white disabled:border-[#E4E9F2]',
  danger:
    'bg-[#FF3D71] text-white border border-transparent hover:bg-[#E6335F] active:bg-[#CC2C54] disabled:bg-[#C5CEE0] disabled:text-white',
  dangerGhost:
    'bg-transparent text-[#DB2C66] border border-transparent hover:bg-[#FFF4F6] active:bg-[#FFE0E9] disabled:text-[#C5CEE0] disabled:bg-transparent',
};

export const BUTTON_SIZE = {
  sm: 'h-8 px-3 text-xs',
  md: 'h-10 px-5 text-sm',
};

export const ICON_BUTTON_SIZE = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
};

export const BUTTON_SHAPE = {
  rounded: 'rounded-lg',
  pill: 'rounded-full',
};

export const buttonClass = (variant = 'secondary', size = 'md', shape = 'rounded') =>
  [
    CONTROL_BASE,
    BUTTON_VARIANT[variant] ?? BUTTON_VARIANT.secondary,
    BUTTON_SIZE[size] ?? BUTTON_SIZE.md,
    BUTTON_SHAPE[shape] ?? BUTTON_SHAPE.rounded,
  ].join(' ');

export const iconButtonClass = (variant = 'ghost', size = 'md', shape = 'rounded') =>
  [
    CONTROL_BASE,
    BUTTON_VARIANT[variant] ?? BUTTON_VARIANT.ghost,
    ICON_BUTTON_SIZE[size] ?? ICON_BUTTON_SIZE.md,
    BUTTON_SHAPE[shape] ?? BUTTON_SHAPE.rounded,
    'shrink-0 p-0',
  ].join(' ');

export const TAB_CLASS = {
  active: `pb-2 text-sm font-semibold text-[#5462FF] border-b-2 border-[#5462FF] ${FOCUS_RING}`,
  inactive: `pb-2 text-sm font-medium text-[#8F9BB3] border-b-2 border-transparent ${FOCUS_RING}`,
};

export const SEVERITY = {
  healthy: '#00B887',
  watch: '#FFB023',
  alert: '#FF8A3D',
  critical: '#FF3D71',
};
